import { Box, Grid, TableContainer } from "@mui/material";
import useWorkersAndMedicalExaminationsModule from "./hooks/useWorkersAndMedicalExaminationsModule";
import TableActionButton from "../../../../components/DataTable/TableActionButton";
import EyeIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DataTable from "../../../../components/DataTable/DataTable";
import { mainTableColumnTitles } from "./consts";
import { getDate } from "../../../../utils/common";
import DrawerManager from "./components/drawers";
import { isExposed } from "./helpers";
import { CarcinogenicModuleFooter } from "../../components/CarcinogenicModuleFooter";
import { TAB_INDEX } from "../../pages";
import InformationStateBadge from "../../components/InformationStateBadge";
import BackdropComponent from "../../../../components/Backdrop/BackdropComponent";
import { useNavigate } from "react-router-dom";

const WorkersAndMedicalExaminationsTabContent = ({
    showCancelCarcinogenicReportAlert,
    handleTabChange,
    onlyVisual
}: any) => {
    const {
        workers,
        selected,
        open,
        setOpen,
        workersAndMedicalExaminationsFilters,
        workersAndMedicalExaminationsTableMenu,
        isFetchingWorkers,
        translate,
        handleClickEditWorkerIcon
    } = useWorkersAndMedicalExaminationsModule();

    const { menuOpen } = workersAndMedicalExaminationsTableMenu;
    const { filters, setFilters } = workersAndMedicalExaminationsFilters;

    const navigate = useNavigate();

    const handleFooterCancelClick = () => {
        if (onlyVisual) {
            handleTabChange(TAB_INDEX.RADIOLOGICAL_EQUIPMENT);
            return;
        }
        showCancelCarcinogenicReportAlert({ confirmAction: () => navigate(-1) });
    };

    return (
        <>
            <Box
                component="div"
                justifyContent="center"
                bgcolor={'#ffffff'}
                borderRadius={'0px 0px 6px 6px'}
                p={3}
            >
                <Grid item xs={12}>
                    <TableContainer>
                        <DataTable
                            // testID={TEST_IDS.table.id}
                            columnTitles={mainTableColumnTitles(translate)}
                            columnWidths={[]}
                            onSelectRow={() => {}}
                            selected={selected}
                            selectedItemFromAction={null}
                            menuOpen={menuOpen}
                            items={workers || []}
                            loading={false}
                            filters={filters}
                            setFilters={setFilters}
                            isFetching={false}
                            headers={[
                                {
                                    type: 'data',
                                    upperLabel: (item: any) => `${item?.nombre}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) => `${item?.cuil}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) =>
                                        `${item?.puestoTrabajo?.nombre || '-'}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) => `${item?.sector?.nombre || '-'}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) =>
                                        `${getDate(item?.fechaIngreso, 'YYYY/MM/DD') || '-'}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) => `${isExposed(item) ? 'SI' : 'NO'}`
                                },
                                {
                                    type: 'data',
                                    upperLabel: (item: any) => (
                                        <InformationStateBadge
                                            state={
                                                item?.estadoInfoCancerigeno === true ||
                                                !isExposed(item)
                                                    ? 'complete'
                                                    : 'incomplete'
                                            }
                                        />
                                    )
                                },
                                {
                                    type: 'data',
                                    lowerLabel: (item: any) => (
                                        <Box display={'flex'} gap={1.5}>
                                            <TableActionButton
                                                disabled={false}
                                                onClick={() => handleClickEditWorkerIcon(item)}
                                                IconComponent={!onlyVisual ? EditIcon : EyeIcon}
                                            />
                                        </Box>
                                    )
                                }
                            ]}
                        />
                    </TableContainer>
                    <DrawerManager
                        open={open}
                        setOpen={setOpen}
                        selectedWorker={selected}
                        translate={translate}
                        onlyVisual={onlyVisual}
                    />
                </Grid>
                <BackdropComponent loading={isFetchingWorkers} />
            </Box>
            <CarcinogenicModuleFooter
                handleCancelClick={handleFooterCancelClick}
                handleSubmitClick={(e: any) =>
                    handleTabChange(e, TAB_INDEX.RESPONSIBLES_AND_CONTRACTORS)
                }
                onlyVisual={onlyVisual}
            />
        </>
    );
};

export default WorkersAndMedicalExaminationsTabContent